import domready from 'domready';
import showStartupError from "./showStartupError.js";
export default function runBrowserMain(mainFn) {
  domready(function () {
    Promise.resolve().then(mainFn)["catch"](showStartupError);
  });
}